/**
 * useRepublishSite hook
 *
 * TanStack mutation wrapping `billingApi.republishSite`. Throws like
 * `usePublishSite` so failures land in `onError`.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { republishSite } from '../api/billingApi';

interface RepublishResult {
  status: string;
  checkoutUrl: string | null;
}

export function useRepublishSite() {
  const queryClient = useQueryClient();
  return useMutation<RepublishResult, Error, string>({
    mutationFn: (siteId) => republishSite(siteId),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
